import React from "react";
import { Heart, X } from "lucide-react";

const KindReminderDialog = ({ open, onAccept, onClose }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
      role="dialog"
      aria-modal="true"
    >
      <div
        className="absolute inset-0 bg-[#1f2a36]/55 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl p-6 sm:p-7 ht-fade-up">
        <button
          onClick={onClose}
          aria-label="Close"
          className="absolute top-3 right-3 text-[#9aa6b2] hover:text-[#2c3e50]"
        >
          <X className="h-4 w-4" />
        </button>
        <div className="flex items-center justify-center">
          <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-[#eaf4fb] text-[#3d6486]">
            <Heart className="h-6 w-6" />
          </span>
        </div>
        <h2 className="mt-4 ht-display text-2xl text-[#2c3e50] text-center">
          Before you share…
        </h2>
        <p className="mt-3 ht-body text-[#5a6b7d] text-center leading-relaxed">
          This is a quiet room. Speak as you would to a tired friend.
          Listen more than you fix. Hold what others share in confidence.
        </p>
        <ul className="mt-4 space-y-2 ht-body text-sm text-[#3d4e62]">
          <li className="ht-bullet">No selling, recruiting, or hot takes.</li>
          <li className="ht-bullet">No screenshots beyond this community.</li>
          <li className="ht-bullet">If someone is in crisis, signpost SOS 1767.</li>
        </ul>
        <button
          onClick={onAccept}
          className="ht-btn mt-6 w-full rounded-md bg-[#b6dcf3] hover:bg-[#a4d1ee] text-[#2c3e50] font-semibold py-3 text-[15px]"
        >
          I’ll be kind. Take me in.
        </button>
      </div>
    </div>
  );
};

export default KindReminderDialog;
